import { Duration } from "luxon";

export interface EditMasterPlanLocationRequest {
    id?: string;
    locationId?: string;
    locationName?: string;
    template?:string;
    serviceHoursFrom?: Duration;
    serviceHoursTo?: Duration;
    address?: string;
    latitude?: number;
    longitude?: number;
    postalCode?: string;
    city?: string;
    country?: string;
    stopTime?: Duration ;
    serviceTime?: Duration;
    pickupCapacityType1?: number;
    pickupCapacityType2?: number;
    pickupCapacityType3?: number;
    deliveryCapacityType1?: number;
    deliveryCapacityType2?: number;
    deliveryCapacityType3?: number;
    priority?: number;
    qualifications?: string;
    stopNumber?: number;
    sequenceNumber?:number;
    planId?: string;
    jobId?: string;
    precedence?: number;
    customData?: string;
    }